import { render } from "./Tickets.vue?vue&type=template&id=290afd18&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=290afd18&lang=scss&scoped=true"

import exportComponent from "/builds/optelgroup/exploration/reusable-components/supply-chain-simulator/prototype/iscp-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290afd18"]])

export default __exports__